import * as angular from "angular";
import {ApiUrl} from "../models/app-config.model";
import {CurrentUser} from "../models/user/user.model";
import {UserService} from "../common/user/user.service";
import {UserSessionService} from "../common/user-session/user-session.service";
import {PreferenceService} from "../common/preference/preference.service";

export interface SidebarRouteParams extends angular.route.IRouteParamsService {
    tenantId: string;
}

export class SidebarController {
    private apiUrl: ApiUrl;
    private origin: string;
    currentUser: CurrentUser;
    districtManagedDefaultGroups: boolean = false;

    /* @ngInject */
    constructor(public $routeParams: SidebarRouteParams, public $location: angular.ILocationService,
                API_URL: ApiUrl, ORIGIN: string, userService: UserService,
                private userSessionService: UserSessionService,
                private preferenceService: PreferenceService) {
        this.apiUrl = API_URL;
        this.origin = ORIGIN;
        userService.get().then(this.loadUser);
    }

    isActivePath(path: string): boolean {
        return `#${this.$location.path()}` === path;
    }

    getPath(path: string): string {
        return `#/${this.$routeParams.tenantId}/${path}`;
    }

    getNtpDashboardPath(): string {
        return `${this.origin}${this.apiUrl.ntpDashboard}`;
    }

    showAssignStudyProgramsToGroups(): boolean {
        return this.currentUser && !this.userSessionService.isDistrictMode() &&
            this.currentUser.isAdmin();
    }

    showManageDefaultPrograms(): boolean {
        return this.currentUser && this.currentUser.isAdmin() &&
            this.userSessionService.isTenantManagingDefaults();
    }

    showSetupApPrograms(): boolean {
        if (!this.currentUser) {
            return false;
        }

        let subscriptionStudyPrograms: any = this.userSessionService.getSubscriptionStudyPrograms();

        if (!subscriptionStudyPrograms || !subscriptionStudyPrograms.apCount) {
            // No AP programs to setup
            return false;
        }

        if (this.currentUser.isDistrictAdmin() && this.userSessionService.isDistrictMode()) {
            return true;
        }

        return this.currentUser.isAdmin() && subscriptionStudyPrograms.isSchoolSubscription;
    }

    private loadUser = (currentUser: CurrentUser): void => {
        this.currentUser = currentUser;
    };
}


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/sidebar/sidebar.controller.ts
 **/